if (!customElements.get('veise-collection-preview')) {
    customElements.define('veise-collection-preview', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.bound === 'true') return;
        this.dataset.bound = 'true';

        this.links = Array.from(this.querySelectorAll('[data-preview-key]'));
        this.panels = Array.from(this.querySelectorAll('[data-preview-panel]'));

        this.links.forEach((link) => {
          const activate = () => this.activate(link.dataset.previewKey);
          link.addEventListener('pointerenter', activate);
          link.addEventListener('focus', activate);
        });
      }

      activate(key) {
        this.links.forEach((link) => link.classList.toggle('is-active', link.dataset.previewKey === key));
        this.panels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.previewPanel === key));
      }
    });
  }
